// 支払方法のエンティティ
export class Payments {
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // カードトークン(不使用) DB型(*varchar1024)
  public card_token?: string;
  // 銀行コード DB型(*varchar256)
  public bank_code?: string;
  // 銀行名 DB型(*varchar256)
  public bank_name?: string;
  // 銀行支店番号 DB型(*varchar256)
  public bank_branch_code?: string;
  // 銀行支店名 DB型(*varchar256)
  public bank_branch?: string;
  // 銀行預金種別 DB型(*varchar20)
  public bank_type?: string;
  // 銀行口座番号 DB型(*varchar20)
  public bank_account_number?: string;
  // 銀行口座名義（カタカナ） DB型(*varchar64)
  public bank_account_name_kana?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Payments {
    const entity = new Payments();
    entity.user_id = record['user_id'];
    entity.card_token = record['card_token'];
    entity.bank_code = record['bank_code'];
    entity.bank_name = record['bank_name'];
    entity.bank_branch_code = record['bank_branch_code'];
    entity.bank_branch = record['bank_branch'];
    entity.bank_type = record['bank_type'];
    entity.bank_account_number = record['bank_account_number'];
    entity.bank_account_name_kana = record['bank_account_name_kana'];
    return entity;
  }
  static getTypeFitEntity(value: any): Payments {
    const entity = new Payments();
    entity.user_id = value.user_id;
    entity.card_token = value.card_token;
    entity.bank_code = value.bank_code;
    entity.bank_name = value.bank_name;
    entity.bank_branch_code = value.bank_branch_code;
    entity.bank_branch = value.bank_branch;
    entity.bank_type = value.bank_type;
    entity.bank_account_number = value.bank_account_number;
    entity.bank_account_name_kana = value.bank_account_name_kana;
    return entity;
  }
}
